export default {
    meta: {
        title: '鱼你在一起-审批详情',
        url: '/fishtogether/approvallist',
        urlName: '鱼你审批'
    }
};
